<template>
  <div class="empty-wrap">
    <img src="@/assets/images/icon/ico_search_g.svg" alt="">
    <p>해당 내용이 없습니다.</p>
  </div>

</template>

<script setup>

</script>